import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Star, Quote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [sectionContent, setSectionContent] = useState({
    title: 'Success Stories',
    subtitle: 'Hear from clients who achieved their visa goals with Visaasure'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Fetch section content
      const contentRes = await axios.get(`${API}/page-content/home`);
      const testimonialsData = contentRes.data.find(item => item.section_name === 'testimonials');
      if (testimonialsData && testimonialsData.content) {
        setSectionContent(testimonialsData.content);
      }

      // Fetch testimonials
      const testimonialsRes = await axios.get(`${API}/testimonials`);
      setTestimonials(testimonialsRes.data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading testimonials...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">{sectionContent.title}</h2>
          <p className="body-large section-subtitle">
            {sectionContent.subtitle}
          </p>
        </div>

        {/* Testimonials */}
        <div className="testimonials-grid">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card hover-lift">
              <div className="quote-icon">
                <Quote size={24} />
              </div>
              
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>

              <p className="body-medium testimonial-text">
                {testimonial.text}
              </p>

              <div className="testimonial-footer">
                <div className="client-info">
                  <div className="client-name heading-3">{testimonial.name}</div>
                  <div className="client-meta caption">
                    {testimonial.location} • {testimonial.visa_type}
                  </div>
                </div>
                <div className="testimonial-date caption">{testimonial.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;